export const fonts = {
    main: 'ff-dagny-web-pro',
    secondFont: '',
    DagnyProRegular: '',
    HelveticaNeueRegular: 'HelveticaNeueRegular'
};
